<template>
  <v-row>
    <v-col v-if="showSearch" md="6">
      <v-text-field
        v-model="search"
        :label="searchLabel"
        single-line
        @keypress.enter="setSearchQueryParams()"
      ></v-text-field>
    </v-col>
    <v-col md="6" class="text-right">
      <div>
        <span>{{ paginationInfo }}</span>
        <v-icon
          v-if="previousLink"
          v-text="$getIcon('mdiChevronLeft')"
          @click="syncFetchApiLink(previousLink)"
        >
        </v-icon>
        <v-icon v-else v-text="$getIcon('mdiChevronLeft')" disabled> </v-icon>
        <v-icon
          v-if="nextLink"
          v-text="$getIcon('mdiChevronRight')"
          @click="syncFetchApiLink(nextLink)"
        >
        </v-icon>
        <v-icon v-else v-text="$getIcon('mdiChevronRight')" disabled> </v-icon>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    showSearch: {
      type: Boolean,
      default: true
    },
    searchLabel: {
      type: String,
      default: ""
    },
    fetchApi: {
      type: String,
      required: true
    },
    nextLink: {
      validator: prop => typeof prop === "string" || prop === null,
      required: true
    },
    previousLink: {
      validator: prop => typeof prop === "string" || prop === null,
      required: true
    },
    paginationInfo: {
      type: String,
      required: true
    },
    filterQuery: {
      type: Object,
      required: false,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      search: "",
      searchData: false
    };
  },
  mounted() {
    if (Object.prototype.hasOwnProperty.call(this.filterQuery, "search")) {
      this.search = this.filterQuery.search;
    }
  },
  methods: {
    syncFetchApiLink(link) {
      this.$emit("update:fetchApi", link);
    },
    setSearchQueryParams() {
      this.$emit("update:queryParams", { search: this.search });
    }
  }
};
</script>
